module.exports = __webpack_public_path__ + "img/20220421181528.9d4e3224.png";